import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import Menu from '@mui/material/Menu';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LogoutIcon } from '@/assets/icons/LogoutIcon';
import { UserIcon } from '@/assets/icons/UserIcon';
import { useSignOut } from '@/core/auth/_hooks/useSignOut';
import { useCurrentUser, useIdToken } from '@/core/store/auth/authSelectors';

import { HeaderMenuItem } from '../HeaderMenuItem/HeaderMenuItem';

import { headerMenuStyles as sx } from './HeaderMenu.styles';

export const HeaderMenu = () => {
	const { t } = useTranslation();
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const idToken = useIdToken();
	const { handleSignOut } = useSignOut();
	const [open, setOpen] = useState(false);
	const user = useCurrentUser();

	const handleClose = () => {
		setOpen(false);
	};

	const handleOpen = () => {
		setOpen(true);
	};

	const handleLogout = useCallback(async () => {
		await handleSignOut();
	}, [handleSignOut]);

	if (!idToken) {
		return null;
	}

	return (
		<>
			<Box ref={setAnchorEl} sx={sx.menuButton}>
				<Avatar sx={sx.avatar} onClick={handleOpen}>
					<UserIcon sx={sx.avatarIcon} />
				</Avatar>
			</Box>

			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'right'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right'
				}}
				disableAutoFocusItem
				disableScrollLock
				disablePortal
				slotProps={{
					paper: {
						sx: sx.menuList
					}
				}}
			>
				{user?.email && (
					<ListItem role='presentation' disablePadding sx={sx.userEmail}>
						{user.email}
					</ListItem>
				)}
				<HeaderMenuItem onClick={handleLogout}>
					<LogoutIcon
						fill={'var(--mui-palette-text-secondary)'}
						sx={sx.logoutIcon}
					/>
					{t('Logout')}
				</HeaderMenuItem>
			</Menu>
		</>
	);
};
